import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'Access-control-allow-headers': 'Authorization',
  },
})

const getAllAdditionalInformations = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/additional-informations',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveAdditionalInformation = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/additional-informations',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateAdditionalInformation = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/additional-informations/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteAdditionalInformation = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/additional-informations/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllAdditionalInformations,
  saveAdditionalInformation,
  updateAdditionalInformation,
  deleteAdditionalInformation,
}
